/**
 * ============================================================================
 * EXPERIMENT: Travel Rhythm Display (ab_travel_rhythm)
 *
 * Backend-driven AB test — variant decided server-side via API
 * `meta.experiment.travelRhythm`. No Amplitude experiment, no entry in
 * `feature-flags.json`: the variant is implicit — the feature renders only
 * when the API returns a rhythm value.
 *
 * PR: #TODO_AFTER_PR_CREATION_ab_travel_rhythm
 * Expected end date: 2026-07-22 (remove all AB_* files and BEGIN/END markers by then).
 *
 * Temporary code — will be REMOVED when the experiment concludes.
 * Find all experiment code: grep -rn "ab_travel_rhythm" src/
 * ============================================================================
 */
import { datadogLogger } from '../../shared/datadog/logger';

import {
    TravelRhythmValue,
    TripProjectExperimentFields,
    TripProjectJSONAPIResponse,
} from './types';

const TRAVEL_RHYTHM_VALUES: ReadonlyArray<TravelRhythmValue> = [
    'single_base',
    'few_stops',
    'frequent_moves',
    'unknown',
];

function isTravelRhythmValue(value: unknown): value is TravelRhythmValue {
    return typeof value === 'string' && (TRAVEL_RHYTHM_VALUES as readonly string[]).includes(value);
}

export function parseTravelRhythmExperiment(
    meta: TripProjectJSONAPIResponse['meta'],
): TripProjectExperimentFields | undefined {
    const travelRhythm = meta?.experiment?.travelRhythm;
    if (travelRhythm === undefined) return undefined;

    if (isTravelRhythmValue(travelRhythm)) {
        return { travelRhythm };
    }

    datadogLogger.error('[TripProject]: Invalid meta.experiment.travelRhythm: unexpected rhythm', {
        travelRhythm,
    });
    return undefined;
}
